import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { AFEntity } from '../model/af.model';
import { AuthService } from '../service/auth.service';

@Injectable({
  providedIn: 'root'
})

export class AuthguardAAApplicant {

  constructor(private userService: AuthService, private router: Router) {
  }

  canActivate(): boolean {
    if (this.userService.getVerifyId() == null) {
      this.router.navigate(['unauthorized']);
    }

    localStorage.setItem('loginType', "2");

    this.userService.getApplicantDetails(false).subscribe({
      next: (data: AFEntity) => {
        sessionStorage.setItem(environment.user_object, JSON.stringify(data));
        if (data.view == "signInView") {
          this.router.navigate(['login']);
        } else if (data.view == "registrationView") {
          this.router.navigate(['createAccount']);
        } else {
          this.router.navigate(['unauthorized']);
        }
      },
      error: () => {
        this.router.navigate(['unauthorized']);
      }
    });

    return true;
  }

}
